import React from 'react';

interface Props {
  items: { label: string; value: string | number; color?: string }[];
}

const ReportSummary: React.FC<Props> = ({ items }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 my-4">
    {items.map((item, i) => (
      <div key={i} className="bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl p-4 text-center shadow-sm">
        <p className={`text-xl font-bold ${item.color || 'text-primary-600 dark:text-primary-400'}`}>
          {typeof item.value === 'number' ? item.value.toLocaleString() : item.value}
        </p>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 font-medium">{item.label}</p>
      </div>
    ))}
  </div>
);

export default ReportSummary;
